import { render, staticRenderFns } from "./shiftManagement.vue?vue&type=template&id=dcd68426&scoped=true&"
import script from "./shiftManagement.vue?vue&type=script&lang=js&"
export * from "./shiftManagement.vue?vue&type=script&lang=js&"
import style0 from "./shiftManagement.vue?vue&type=style&index=0&id=dcd68426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd68426",
  null
  
)

export default component.exports